//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  SIGN_OUT: 'Sign out',
});
